/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IS_REGION_AU_OR_NZ } from '@gh/common-shared';

import { JobFinancialsTradingAccount } from '../../../resources/job-financials.model';

@Component({
  selector: 'gh-job-financials-trading-account',
  template: require('./job-financials-trading-account.component.html'),
  styles: [require('./job-financials-trading-account.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFinancialsTradingAccountComponent {

  @Input() tradingAccount: JobFinancialsTradingAccount;

  get isAuOrNzRegion(): boolean {
    return IS_REGION_AU_OR_NZ;
  }
}
